"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _helpers = require("utils/helpers");

var FilterPanel = /*#__PURE__*/function () {
  function FilterPanel(component) {
    (0, _classCallCheck2["default"])(this, FilterPanel);
    this.dom = {
      $component: component,
      $close: Array.from(document.querySelectorAll('.js-filter-panel-close')),
      $reset: Array.from(document.querySelectorAll('.js-filter-panel-reset')),
      $resetButtonHidden: Array.from(document.querySelectorAll('.js-filter-panel-reset-hidden')),
      $headerShow: Array.from(document.querySelectorAll('.js-header-show-filter-panel')),
      $counter: Array.from(document.querySelectorAll('.js-filter-panel-counter')),
      $content: component.querySelector('.js-filter-panel-ajax-content'),
      $counts: Array.from(document.querySelectorAll('.js-filter-panel-count')),
      $sort: Array.from(document.querySelectorAll('.js-filter-panel-sort')),
      $filters: Array.from(document.querySelectorAll('.js-filter-panel-filter')),
      $checkboxes: Array.from(document.querySelectorAll('.js-filter-panel-checkbox input[type=checkbox]')),
      $modelView: Array.from(document.querySelectorAll('.js-filter-panel-modelview input[type=checkbox]')),
      $productCalloutGrid: document.querySelector('.ProductCalloutGrid'),
      $productCards: document.querySelector('.ProductCalloutGrid__cards')
    }, this.state = {
      open: false,
      animating: false,
      loading: false,
      requiredReload: false,
      modelView: false,
      sort: 'featured',
      checkboxes: '',
      activeFilters: 0,
      openDuration: 500,
      closeDuration: 750,
      activeClass: 'is-active',
      parser: new DOMParser(),
      isShitBrowser: (0, _helpers.isOldIE)(),
      collection: component.getAttribute('data-collection'),
      newFilterURL: component.getAttribute('data-collection')
    };
    this.toggleHandler = this.toggle.bind(this);
    this.keydownHandler = this.onKeydown.bind(this);
    this.updateCartHandler = this.update.bind(this);
    this.clickHandler = this.close.bind(this);
    this.filterHandler = this.filter.bind(this);
    this.sortHandler = this.sort.bind(this);
    this.resetHandler = this.reset.bind(this);
    this.checkboxHandler = this.refreshProducts.bind(this);
    this.modelViewToggle = this.toggleModelview.bind(this);
    this.mount(); //to remove:
    //this.toggle();
  }

  (0, _createClass2["default"])(FilterPanel, [{
    key: "mount",
    value: function mount() {
      var _this = this;

      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('FilterPanel : connect', this);
      document.addEventListener('keydown', this.keydownHandler);
      document.addEventListener('updateFilterPanel', this.updateCartHandler);
      dom.$close.forEach(function ($element) {
        return $element.addEventListener('click', _this.clickHandler);
      });
      dom.$filters.forEach(function ($element) {
        return $element.addEventListener('click', _this.filterHandler);
      });
      dom.$sort.forEach(function ($element) {
        return $element.addEventListener('click', _this.sortHandler);
      });
      dom.$reset.forEach(function ($element) {
        return $element.addEventListener('click', _this.resetHandler);
      });
      dom.$checkboxes.forEach(function ($element) {
        return $element.addEventListener('change', _this.checkboxHandler);
      });
      dom.$modelView.forEach(function ($element) {
        return $element.addEventListener('change', _this.modelViewToggle);
      });
      console.log((0, _helpers.isOldIE)());

      if (!state.isShitBrowser) {
        dom.$headerShow.forEach(function ($element) {
          return $element.addEventListener('click', _this.toggleHandler);
        });
      }

      this.setFilters();
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this2 = this;

      var self = this;
      var dom = this.dom;
      console.log('FilterPanel : connect', this);
      dom.$headerShow.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.toggleHandler);
      });
      document.removeEventListener('keydown', this.keydownHandler);
      document.removeEventListener('updateFilterPanel', this.updateCartHandler);
      dom.$close.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.clickHandler);
      });
      dom.$filters.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.filterHandler);
      });
      dom.$sort.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.sortHandler);
      });
      dom.$reset.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.resetHandler);
      });
      dom.$checkboxes.forEach(function ($element) {
        return $element.removeEventListener('change', _this2.checkboxHandler);
      });
      dom.$modelView.forEach(function ($element) {
        return $element.removeEventListener('change', _this2.modelViewToggle);
      });
    }
  }, {
    key: "toggleModelview",
    value: function toggleModelview(event) {
      var dom = this.dom,
          state = this.state;
      console.log('FilterPanel : toggleModelview', this);

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (state.modelView) {
        dom.$productCalloutGrid.classList.remove('ProductCalloutGrid--modelview');
        state.modelView = false;
      } else {
        dom.$productCalloutGrid.classList.add('ProductCalloutGrid--modelview');
        state.modelView = true;
      }
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      var dom = this.dom,
          state = this.state;
      console.log('FilterPanel : toggle', this);

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (state.open) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "removeParameterFromUrl",
    value: function removeParameterFromUrl(url, parameter) {
      return url.replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1').replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
    }
  }, {
    key: "updateQueryStringParameter",
    value: function updateQueryStringParameter(uri, key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = uri.indexOf('?') !== -1 ? "&" : "?";

      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
      } else {
        return uri + separator + key + "=" + value;
      }
    }
  }, {
    key: "filterProducts",
    value: function filterProducts() {
      var dom = this.dom,
          state = this.state;
      console.log('FilterPanel : filter products');
      var colorFilters = document.querySelectorAll(".js-filter-panel-filter.active[data-filter-color]");

      if (colorFilters.length > 0) {
        state.activeFilters = state.activeFilters + colorFilters.length;
        document.querySelectorAll(".ProductCalloutGrid__card").forEach(function (el) {
          el.classList.add('inactive');
        });
        var URLParamsColor = '';
        colorFilters.forEach(function (filter) {
          document.querySelectorAll(".ProductCalloutGrid__card[data-color='color_" + filter.getAttribute('data-filter-color') + "']").forEach(function (el) {
            el.classList.remove('inactive');
          });
          URLParamsColor = URLParamsColor + '+' + filter.getAttribute('data-filter-color');
        });
      } else {
        document.querySelectorAll(".ProductCalloutGrid__card").forEach(function (el) {
          el.classList.remove('inactive');
        });
      }

      var sizeFilters = document.querySelectorAll(".js-filter-panel-filter.active[data-filter-size]");

      if (sizeFilters.length > 0) {
        state.activeFilters = state.activeFilters + sizeFilters.length;
        document.querySelectorAll(".ProductCalloutGrid__card:not(.inactive)").forEach(function (el) {
          el.classList.add('inactiveTemp');
        });
        var URLParamsSize = '';
        sizeFilters.forEach(function (filter) {
          document.querySelectorAll(".ProductCalloutGrid__card[data-size*='" + filter.getAttribute('data-filter-size') + "']:not(.inactive)").forEach(function (el) {
            el.classList.remove('inactiveTemp');
          });
          URLParamsSize = URLParamsSize + '+' + filter.getAttribute('data-filter-size');
        });
        document.querySelectorAll(".ProductCalloutGrid__card.inactiveTemp").forEach(function (el) {
          el.classList.add('inactive');
          el.classList.remove('inactiveTemp');
        });
      }

      dom.$counts.forEach(function ($count) {
        return $count.innerHTML = document.querySelectorAll('.ProductCalloutGrid__card:not(.inactive)').length;
      });
      state.loading = false;
      var urlParams = state.newFilterURL;

      if (URLParamsColor) {
        urlParams = this.updateQueryStringParameter(urlParams, "color", URLParamsColor.substring(1));
      } else {
        urlParams = this.removeParameterFromUrl(urlParams, "color");
      }

      if (URLParamsSize) {
        urlParams = this.updateQueryStringParameter(urlParams, "size", URLParamsSize.substring(1));
      } else {
        urlParams = this.removeParameterFromUrl(urlParams, "size");
      }

      state.newFilterURL = urlParams;
      dom.$counter.forEach(function ($el) {
        return $el.innerHTML = state.activeFilters;
      });
      dom.$resetButtonHidden.forEach(function ($el) {
        if (state.activeFilters == 0) {
          $el.classList.add('inactive');
        } else {
          $el.classList.remove('inactive');
        }
      });
      Array.from(document.querySelectorAll('.ProductCalloutGrid__card-big')).forEach(function ($el) {
        if (state.activeFilters == 0) {
          $el.classList.remove('inactive');
        } else {
          $el.classList.add('inactive');
        }
      });
      window.history.pushState({}, document.title, state.newFilterURL);
    }
  }, {
    key: "refreshProducts",
    value: function refreshProducts() {
      var dom = this.dom,
          state = this.state;
      var t = this;

      if (state.loading == false) {
        state.activeFilters = 0;
        var refreshURL = state.collection;
        var checkboxes = '';
        dom.$checkboxes.forEach(function ($element) {
          if ($element.checked) {
            checkboxes += "+" + $element.getAttribute("name");
            state.activeFilters = state.activeFilters + 1;
          }
        });

        if (checkboxes) {
          checkboxes = checkboxes.substring(1);
          refreshURL = refreshURL + '/' + checkboxes;
        }

        dom.$sort.forEach(function ($element) {
          if ($element.classList.contains('active')) {
            var selectedSort = $element.getAttribute('data-filter-sort');

            if (selectedSort != state.sort || checkboxes != state.checkboxes) {
              state.loading = true;
              refreshURL = refreshURL + '?sort_by=' + selectedSort;
              (0, _axios["default"])({
                method: 'get',
                url: refreshURL
              }).then(function (response) {
                var html = state.parser.parseFromString(response.data, 'text/html');
                dom.$productCards.innerHTML = html.querySelector('.ProductCalloutGrid__cards').innerHTML;
                var mountComponentsEvent = new CustomEvent('theme:refreshComponents', {
                  detail: {
                    scope: dom.$productCards
                  }
                });
                document.dispatchEvent(mountComponentsEvent);
                state.sort = selectedSort;
                state.checkboxes = checkboxes;
                state.newFilterURL = refreshURL;
                t.filterProducts();

                if (state.requiredReload) {
                  state.requiredReload = false;
                  t.refreshProducts();
                }
              })["catch"](function (response) {
                window.location.reload();
              });
            } else {
              t.filterProducts();
            }
          }
        });
      } else {
        state.requiredReload = true;
      }
    }
  }, {
    key: "sort",
    value: function sort(event) {
      var dom = this.dom,
          state = this.state;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      dom.$sort.forEach(function ($element) {
        return $element.classList.remove('active');
      });
      event.currentTarget.classList.add('active');
      this.refreshProducts();
    }
  }, {
    key: "filter",
    value: function filter(event) {
      var dom = this.dom,
          state = this.state;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      event.currentTarget.classList.toggle('active');
      this.refreshProducts();
    }
  }, {
    key: "reset",
    value: function reset() {
      var dom = this.dom,
          state = this.state;
      dom.$filters.forEach(function ($element) {
        if ($element.classList.contains('active')) {
          $element.classList.remove('active');
        }
      });
      dom.$checkboxes.forEach(function ($element) {
        $element.checked = false;
      });
      this.refreshProducts();
    }
  }, {
    key: "setFilters",
    value: function setFilters() {
      var dom = this.dom,
          state = this.state;
      var url = new URL(window.location.href);
      var sortBy = url.searchParams.get("sort_by");
      var paramColor = url.searchParams.get("color");
      var paramSize = url.searchParams.get("size");
      var preorder = url.searchParams.get("preorder");
      var comingSoon = url.searchParams.get("coming-soon");

      if (sortBy) {
        state.sort = sortBy;
        var sortButtons = Array.from(document.querySelectorAll('[data-filter-sort="' + sortBy + '"]'));
        sortButtons.forEach(function ($element) {
          return $element.classList.add("active");
        });
      } else {
        var sortButtons = Array.from(document.querySelectorAll('[data-filter-sort="featured"]'));
        sortButtons.forEach(function ($element) {
          return $element.classList.add("active");
        });
      }

      if (paramColor) {
        var colors = paramColor.split(' ');
        colors.forEach(function (color) {
          var colorButtons = Array.from(document.querySelectorAll('[data-filter-color="' + color + '"]'));
          colorButtons.forEach(function ($element) {
            return $element.classList.add("active");
          });
        });
      }

      if (paramSize) {
        var sizes = paramSize.split(' ');
        sizes.forEach(function (size) {
          var sizeButtons = Array.from(document.querySelectorAll('[data-filter-size="' + size.toUpperCase() + '"]'));
          sizeButtons.forEach(function ($element) {
            return $element.classList.add("active");
          });
        });
      }

      if (url.pathname.includes("preorder")) {
        document.querySelector('.js-filter-panel-checkbox input[name="preorder"]').checked = true;
      }

      if (url.pathname.includes("coming_soon")) {
        document.querySelector('.js-filter-panel-checkbox input[name="coming_soon"]').checked = true;
      }

      if (paramColor || paramSize || preorder || comingSoon) {
        this.refreshProducts();
      }

      document.querySelectorAll('[data-filter-color]:not(.active)').forEach(function (el) {
        if (document.querySelectorAll(".ProductCalloutGrid__card[data-color='color_" + el.getAttribute('data-filter-color') + "']").length == 0) {
          el.remove();
        }
      });
      document.querySelectorAll('[data-filter="colors"]').forEach(function (el) {
        if (el.querySelectorAll('[data-filter-color]').length == 0) {
          el.remove();
        }
      });
      document.querySelectorAll('[data-filter-size]:not(.active)').forEach(function (el) {
        if (document.querySelectorAll(".ProductCalloutGrid__card[data-size*='" + el.getAttribute('data-filter-size') + "']").length == 0) {
          el.remove();
        }
      });
      document.querySelectorAll('[data-filter="sizes"]').forEach(function (el) {
        if (el.querySelectorAll('[data-filter-size]').length == 0) {
          el.remove();
        }
      });
    }
  }, {
    key: "open",
    value: function open() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('FilterPanel : open', this); //this.filter();

      if (!state.animating) {
        state.animating = true;
        dom.$component.setAttribute('aria-hidden', false);
        setTimeout(function () {
          dom.$component.classList.add(state.activeClass);
          dom.$headerShow.forEach(function ($element) {
            return $element.classList.add(state.activeClass);
          });
        }, 25);
        setTimeout(function () {
          state.open = true;
          state.animating = false;
          self.notify('open');
        }, state.openDuration);
      }
    }
  }, {
    key: "close",
    value: function close() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('FilterPanel : close', this);

      if (!state.animating) {
        state.animating = true;
        setTimeout(function () {
          dom.$component.classList.remove(state.activeClass);
          dom.$headerShow.forEach(function ($element) {
            return $element.classList.remove(state.activeClass);
          });
        }, 25);
        setTimeout(function () {
          dom.$component.setAttribute('aria-hidden', true);
          state.open = false;
          state.animating = false;
          self.notify('close');
        }, state.closeDuration);
      }
    }
  }, {
    key: "notify",
    value: function notify(action) {
      var dom = this.dom,
          state = this.state;
      console.log('FilterPanel : notify', this);
      var FilterPanelEvent = new CustomEvent("FilterPanel:".concat(action));
      document.dispatchEvent(FilterPanelEvent);
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      var state = this.state;
      console.log('FilterPanel : onKeydown', this, event);
      var escape = event.keyCode === 27;

      if (state.open && escape) {
        this.close();
      }
    }
  }, {
    key: "update",
    value: function update(event) {
      var dom = this.dom,
          state = this.state;
      console.log('FilterPanel : update', this, event);
      var data = event.detail;
      var html = state.parser.parseFromString(data, 'text/html');
      var content = html.querySelector('.js-filter-panel-ajax-content').innerHTML;
      var total = html.querySelector('.js-filter-panel-total').innerHTML;
      var count = html.querySelector('.js-filter-panel-count').innerHTML;
      dom.$content.innerHTML = content;
      dom.$counts.forEach(function ($count) {
        return $count.innerHTML = count;
      });
      this.open();
      var mountComponentsEvent = new CustomEvent('theme:refreshComponents', {
        detail: {
          scope: dom.$content
        }
      });
      document.dispatchEvent(mountComponentsEvent);
    }
  }]);
  return FilterPanel;
}();

exports["default"] = FilterPanel;